const theme = {
	colors: {
		background: '#121212'
	}
};

export default theme;
